import Papaparse from 'papaparse';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';

import { productsImport } from '../../actions';
import withNotifications from '../../../../common/withNotifications';
import { ensurePapaParseOrder } from '../helpers';

const enhance = compose(
  connect(null, { productsImport }),
  withNotifications,
  withState('preview', 'setPreview', null),
  withState('busy', 'setBusy', null),
  withHandlers({
    onChange: props => (e) => {
      props.setPreview(null);
      Papaparse.parse(e.target.files[0], {
        header: true,
        skipEmptyLines: true,
        preview: 100,
        complete: (parseResult) => {
          if (!props.previewOrder) {
            props.setPreview(parseResult);
            return;
          }

          const results = ensurePapaParseOrder({
            parseResult,
            orderedHeaders: props.previewOrder,
            showMissingColumns: true,
          });
          props.setPreview(results);
        },
        transform: (value) => {
          // make sure items forced to be displayed as a string(i.g. '="test"') look good in preview
          const match = (/^=["|'](.*)["|']$/ig).exec(value);
          return match ? match[1] : value;
        },
      });
    },
    onSubmit: props => (e) => {
      e.preventDefault();
      props.setBusy(true);
      return props.import(props.params.id, e.target.csv.files[0])
        .then((response) => {
          props.setBusy(false);
          return response;
        })
        .catch((error) => {
          props.setBusy(false);
          throw error;
        });
    },
  })
);

export default enhance;
